module.exports = __webpack_public_path__ + "img/card-rect-icon-orange.3023dd6.png";